<template>
  <div>
    <OverlayPanel
      :ref="'opActions'"
      @click="toggle"
      appendTo="body"
      :showCloseIcon="true"
      id="overlay_panel"
      style="width: 150px;"
      :baseZIndex=-10
    >
      <div style="padding: 0px 1px">
        <div class="row" style="background-color: white;">
          <div class="col col-lg-12 col-md-12">
            <Button 
              v-for="(obj, index) in getButtons(selectedRow)" 
              :key="index" 
              :label="obj.label" 
              :icon="obj.icon"
              class="p-button-text p-button-plain" 
              @click="obj.command()"
            />
          </div>
        </div>
      </div>
    </OverlayPanel>

    <DataTable
      :value="activities"
      :paginator="true"
      dataKey="customerId"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="50"
      :rowHover="true"
      :selection.sync="selectedContacts"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} Tasks & Events"
      :scrollable="true"
      scrollHeight="400px"
      frozenWidth="50px"
      :style="{ 'width': '100%' }"
      :resizableColumns="true" 
      columnResizeMode="expand"
    >
      <template #empty> No tasks or events found. </template>
      <template #loading> Loading tasks and events. Please wait. </template>
      <!-- <Column selectionMode="multiple" headerStyle="width: 3em;"></Column> -->
      <Column 
        header="Actions"
        headerStyle="width: 50px; padding: 7.5px 0px;"
        :frozen="true"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
            <Button 
              icon="pi pi-ellipsis-h" 
              class="p-button-rounded p-button-text"
              @click="toggleActions($event, slotProps.data)"
            />
          </div>
        </template>
      </Column>
      <Column
        field="activityId"
        header="Id"
        headerStyle="width: 8em; padding: 7.5px 0px;"
        :sortable="true"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
            {{ slotProps.data.activityId }}
          </div>
        </template>
      </Column>
      <Column
        field="activityStatus"
        header="Status"
        headerStyle="width: 10em; padding: 7.5px 0px;"
        :sortable="true"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
            {{ slotProps.data.activityStatus && slotProps.data.activityStatus.statusName ? slotProps.data.activityStatus.statusName : '' }}
          </div>
        </template>
      </Column>
      <Column
        field="activityType"
        header="Type"
        headerStyle="width: 8em; padding: 7.5px 0px;"
        :sortable="true"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
            {{ slotProps.data.activityType && slotProps.data.activityType.activityTypeName ? slotProps.data.activityType.activityTypeName : '' }}
          </div>
        </template>
      </Column>
      <Column
        field="activity"
        header="activity"
        headerStyle="width: 9em; padding: 7.5px 0px;"
        :sortable="true"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
            {{ slotProps.data.quoteVer }}
          </div>
        </template>
      </Column>
      <Column
        field="versionDate"
        header="activity Date"
        headerStyle="width: 8em; padding: 7.5px 0px;"
        :sortable="true"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
            {{ slotProps.data.quoteVerDate }}
          </div>
        </template>
      </Column>
      <Column
        field="customerId"
        header="Customer Id"
        headerStyle="width: 13em; padding: 7.5px 0px;"
        :sortable="true"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
            {{ slotProps.data.customer && slotProps.data.customer.customerId ? slotProps.data.customer.customerId : '' }}
          </div>
        </template>
      </Column>
      <Column
        field="mbpBranch"
        header="Branch"
        headerStyle="width: 10em; padding: 7.5px 0px;"
        :sortable="true"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
            {{ slotProps.data.mbpBranch && slotProps.data.mbpBranch.branchName ? slotProps.data.mbpBranch.branchName : '' }}
          </div>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>
export default {
  props: [
    'activities', 
    'loading'
  ],
  data() {
    return {
      selectedContacts: null,
      filters: {
        global: ''
      },
      selectedRow: null
    }
  },
  created() {
    this.filters.global = this.$route.query.search
  },
  computed: {
    myPermissions() {
      return this.$store.getters['auth/getUserPermissions']
    },
  },
  methods: {
    async toggle(event) {
      this.$refs.op.toggle(event);
    },
    toggleActions(event, data) {
      this.selectedRow = data
      this.$refs.opActions.toggle(event);
    },
    getButtons(data) { 
      let buttons = []

      buttons.push(
        {
          label: 'Delete',
          icon: 'pi pi-trash',
          command: () => {
            this.deleteActivity(data)
          }
        }
      )
      return buttons
    },
    deleteActivity(activity) {
      let permission = this.myPermissions.find(a => a.permission.permissionCode === 'DeleteActivity');
        if (permission) {
          if (permission.permissionLevel !== 0) {
            // only then you can do the deletion
          } else {
              this.$toast.add({
                severity: "error",
                summary: "Not allowed",
                detail: "You are not allowed to delete a task or event",
                life: 5000,
              })
          }
        }
    },
    editActivity(activity) {
      
    }
  }
}
</script>

<style>

</style>